import style from './Stepper.css';
export default function Stepper({
  className = '',
  activeStep = 1,
  children,
  ...props
}) {
  const stepsToRender = children.map((step, i) => {
    if (i + 1 === activeStep) step.props.isActive = true;
    return step;
  });
  return (
    <div className={`${className} ${style.stepper}`} {...props}>
      {stepsToRender}
    </div>
  );
}
